import { useEffect, useState } from 'react';
import { ThemeContext, type Theme } from './theme-context';
import { safeLocalStorage } from '../lib/safeStorage';

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState<Theme>(() => {
    const stored = safeLocalStorage.getItem('theme');
    return stored === 'dark' ? 'dark' : 'light';
  });

  useEffect(() => {
    safeLocalStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t: Theme) => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;

